/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import PromiseQuery from "../../../Basis/Queries/PromiseQuery";
import Query from "../../../Basis/Queries/Query";
import { nameof } from "../../../Basis/Utils/AnyUtil";
import { FilterOperator, FilterWert, FilterWertAls } from "../../DomainDrivenDesign/Commands/Filter";
import ExportvorlageFuer from "../Commands/ExportvorlageFuer";

const QUERY_NAME = "Exporte_LadeExportvorlage";

export interface ExportvorlageFeld {
    exportvorlageFeldId: string;
    name: string;
    zusatzfeldDefinitionId?: string;
    sortierung: number;
    istZuExportieren: boolean;
    exportvorlageId: string;
}

export interface ExportvorlageFilter {
    exportvorlageFilterId: string
    feld: string
    zusatzfeldDefinitionId?: string;
    operator: FilterOperator
    wert: FilterWert
    exportvorlageId: string
}

export interface Exportvorlage {
    exportvorlageId: string;
    geaendert: string;
    fuer: ExportvorlageFuer;
    name: string;
    felder: ExportvorlageFeld[];
    filter: ExportvorlageFilter[];
}

const QUERY = gql`
    query ${QUERY_NAME}($input: ${QUERY_NAME}) {
        ${QUERY_NAME}(input: $input) {
            ${nameof<Exportvorlage>("exportvorlageId")}
            ${nameof<Exportvorlage>("geaendert")}
            ${nameof<Exportvorlage>("fuer")}
            ${nameof<Exportvorlage>("name")}
            ${nameof<Exportvorlage>("felder")} {
                ${nameof<ExportvorlageFeld>("exportvorlageFeldId")}
                ${nameof<ExportvorlageFeld>("name")}
                ${nameof<ExportvorlageFeld>("zusatzfeldDefinitionId")}
                ${nameof<ExportvorlageFeld>("sortierung")}
                ${nameof<ExportvorlageFeld>("istZuExportieren")}
                ${nameof<ExportvorlageFeld>("exportvorlageId")}
            }
            ${nameof<Exportvorlage>("filter")} {
                ${nameof<ExportvorlageFilter>("exportvorlageFilterId")}
                ${nameof<ExportvorlageFilter>("feld")}
                ${nameof<ExportvorlageFilter>("zusatzfeldDefinitionId")}
                ${nameof<ExportvorlageFilter>("operator")}
                ${nameof<ExportvorlageFilter>("wert")} {
                    ${nameof<FilterWert>("als")} {
                        ${nameof<FilterWertAls>("string")}
                        ${nameof<FilterWertAls>("stringArray")}
                        ${nameof<FilterWertAls>("integer")}
                        ${nameof<FilterWertAls>("decimal")}
                        ${nameof<FilterWertAls>("boolean")}
                        ${nameof<FilterWertAls>("dateTime")}
                        ${nameof<FilterWertAls>("enum")}
                        ${nameof<FilterWertAls>("guid")}
                    }
                    ${nameof<FilterWert>("typ")}
                }
                ${nameof<ExportvorlageFilter>("exportvorlageId")}
            }
        }
    }
`;

export interface LadeExportvorlageInput {
    exportvorlageId: string;
}

export class PromiseLadeExportvorlage extends PromiseQuery<Exportvorlage, LadeExportvorlageInput> {
    public static queryName = QUERY_NAME;

    public constructor() {
        super(QUERY);
    }

    public get name(): string {
        return LadeExportvorlage.queryName;
    }
}

export default class LadeExportvorlage extends Query<Exportvorlage, LadeExportvorlageInput> {
    public static queryName = QUERY_NAME;

    public constructor(input: LadeExportvorlageInput, onCompleted: (daten: Exportvorlage) => void) {
        super(QUERY, onCompleted, input);
    }

    public get name(): string {
        return LadeExportvorlage.queryName;
    }
}
